const useRefreshTrigger = {
  methods: {
    useRefreshTrigger() {
      this.$ScrollTrigger.refresh(true)
    },
  },
}

export { useRefreshTrigger }
